export default __webpack_public_path__ + "static/media/EmptySales.7064e84e.svg";